// Shared utility for invoice date range filtering
import { formatDateYMD, getTodayYMD } from '../../../utils/dateUtils';

export interface DateRange {
  fromDate: string;
  toDate: string;
}

export interface RangeOption {
  key: string;
  label: string;
}

// Quick ranges for date presets
export const ranges: RangeOption[] = [
  { key: 'Today', label: 'Today' },
  { key: 'Last_7', label: 'Last 7 days' },
  { key: 'Last_30', label: 'Last 30 days' },
  { key: 'This_Month', label: 'This Month' },
  { key: 'Last_Month', label: 'Last Month' },
];

/**
 * Clone a Date to midnight local time (strips time component).
 */
const cloneDate = (d: Date): Date =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate());

/**
 * Compute a { fromDate, toDate } range (YYYY-MM-DD) for the given preset key.
 * Uses dateUtils for all formatting.
 */
export function getRangeDates(key: string): DateRange {
  const today = new Date();
  const todayStr = getTodayYMD();

  switch (key) {
  case 'Today': {
    return { fromDate: todayStr, toDate: todayStr };
  }
  case 'Last_7': {
    const from = cloneDate(today);
    from.setDate(from.getDate() - 6);
    return { fromDate: formatDateYMD(from), toDate: todayStr };
  }
  case 'Last_30': {
    const from = cloneDate(today);
    from.setDate(from.getDate() - 29);
    return { fromDate: formatDateYMD(from), toDate: todayStr };
  }
  case 'This_Month': {
    const from = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return { fromDate: formatDateYMD(from), toDate: formatDateYMD(end) };
  }
  case 'Last_Month': {
    const from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const end = new Date(today.getFullYear(), today.getMonth(), 0);
    return { fromDate: formatDateYMD(from), toDate: formatDateYMD(end) };
  }
  default:
    return { fromDate: '', toDate: '' };
  }
}
